import $ from "jquery";

$(function () {
    $('[data-component="smoelenboek"]').each(function () {
        var $holder = $(this);

        $holder.slick(
            {
                prevArrow: '<button class="carousel__prev slick-prev"></button>',
                nextArrow: '<button class="carousel__next slick-next"></button>',
                dots: true,
                rows: 0,
                dotsClass: 'carousel__pager',
                slidesToShow: 2,
                infinite: true,
                variableWidth: false,
                autoplay: false,
                mobileFirst: true,
                adaptiveHeight: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: 'unslick'
                    },
                ]
            }
        );
    });
});